import "./Training.module.css";
import HeaderNavigazione from "@/reusable_sections/Header";
import LaTuaSicurezzaIniziaConLaFormazione from "./sections/LaTuaSicurezzaIniziaConLaFormazione";
import INostriCorsiDiFormazione from "./sections/INostriCorsiDiFormazione";
import Courses from "./sections/Courses";
import LatestNews from "./sections/LatestNews";
import Footer from "@/reusable_sections/Footer";
import RecentChronicles from "./sections/RecentChronicles";
export default function TrainingPage() {
  return <div>
      <HeaderNavigazione />
      <LaTuaSicurezzaIniziaConLaFormazione />
      <RecentChronicles />
 
      <INostriCorsiDiFormazione />
      <LatestNews />
      <Footer />
    </div>;
}